module.exports = __webpack_public_path__ + "static/img/wx_qrcode_banner.bcdad35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx_qrcode_banner.png
// module id = GUXw
// module chunks = 2